import { CapaPaymentMethodType } from '@generated/graphql';
import Axios from 'axios';
import { formatDate } from './formatter';
import AppConfig from '@config';

const sendPaymentWebhook = ({
  projectName,
  amount,
  method
}: {
  projectName: string;
  amount: number;
  method: CapaPaymentMethodType;
}) => {
  const isTest =
    window.location.host.includes('test') ||
    window.location.host.includes('bluegreen');
  if (!AppConfig.TeamsPaymentWebhookURL || isTest) return;

  try {
    Axios.post(
      AppConfig.TeamsPaymentWebhookURL,
      `{
        "@type": "MessageCard",
        "@context": "http://schema.org/extensions",
        "themeColor": "0076D7",
        "summary": "발주서 발행",
        "sections": [
            {
                "activityTitle": "발주서가 발행됐어요",
                "activitySubtitle": "총 결제금액 ${amount.toLocaleString()}원",
                "activityImage": "https://teamsnodesample.azurewebsites.net/static/img/image5.png",
                "facts": [
                    {
                        "name": "프로젝트명",
                        "value": "${projectName}"
                    },
                    {
                        "name": "발주금액",
                        "value": "${amount.toLocaleString()}원"
                    },
                    {
                        "name": "결제일자",
                        "value": "${formatDate(
                          new Date().toISOString(),
                          'YYYY년 MM월 DD일 HH시 mm분 ss초'
                        )}"
                    },
                    {
                        "name": "결제수단",
                        "value": "${
                          method === CapaPaymentMethodType.CreditCard
                            ? '카드결제'
                            : '무통장입금'
                        }"
                    }
                ],
                "markdown": true
            }
        ],
        "potentialAction": [
            {
                "@type": "OpenUri",
                "name": "BO에서 확인하기",
                "targets": [
                    {
                        "os": "default",
                        "uri": "https://bo.capa.ai/transaction"
                    }
                ]
            }
        ]
    }`
    );
  } catch (e) {
    console.log(e);
  }
};

export default sendPaymentWebhook;
